<template>
  <div>
    <Modal title="上号" v-model="visible" width="400" class="my-modal top" :mask-closable="false" :footer-hide="true">
      <Form ref="form" v-if="visible" :model="formData" class="page-form" :label-width="80">
        <FormItem prop="certificateNumber" key="certificateNumber" label="执业证号" class="full"
          :rules="$units.formRule.required('请输入')">
          <Input v-model="formData.certificateNumber" placeholder="请输入" />
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save" :loading="loading">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        certificateNumber: '',//上号执业证号
      },
    };
  },
  methods: {
    save() {
      this.$refs.form.validate().then(async isok => {
        if (!isok) {
          return;
        }
        this.$http({
          url: "/buz/userBase/updateCertificateNumber",
          type: "POST",
          data: this.formData,
        }).then((res) => {
          this.$Message.success('操作成功')
          this.visible = false;
          this.$emit('success')
        })
      })
    },
    open(data) {
      data = JSON.parse(JSON.stringify(data));
      this.visible = true;
      this.$refs.form && this.$refs.form.resetFields();
      this.formData.userId = data.id;
    },
  },
};
</script>
<style lang="scss" scoped></style>